import apiClient, { safeJson } from '@/api/client';
import {
    CreateTemplateBody, GroupClassTemplate,
    CreateSessionBody, CreateSessionResponse, GroupSession, GroupSessionDetailResponse,
    DeleteSessionScope, DeleteGroupSessionResponse,
} from './types';

/* ═══════ 수업 템플릿 ═══════ */

export const createTemplate = async (centerId: string, body: CreateTemplateBody) => {
    const res = await apiClient.post(`v1/centers/${centerId}/group-class-templates`, { json: body });
    return { status: res.status, data: await safeJson(res) as { success: boolean; template: GroupClassTemplate } | null };
};

export const getTemplates = async (centerId: string, params?: Record<string, string>) => {
    const res = await apiClient.get(`v1/centers/${centerId}/group-class-templates`, { searchParams: params });
    return { status: res.status, data: await safeJson(res) as { success: boolean; results: GroupClassTemplate[] } | null };
};

export const getTemplate = async (centerId: string, templateId: string) => {
    const res = await apiClient.get(`v1/centers/${centerId}/group-class-templates/${templateId}`);
    return { status: res.status, data: await safeJson(res) as { success: boolean; template: GroupClassTemplate } | null };
};

export const updateTemplate = async (centerId: string, templateId: string, body: Partial<CreateTemplateBody>) => {
    const res = await apiClient.put(`v1/centers/${centerId}/group-class-templates/${templateId}`, { json: body });
    return {
        status: res.status,
        data: await safeJson(res) as { success: boolean; template: GroupClassTemplate; appliedFutureSessionCount?: number } | null,
    };
};

export const deleteTemplate = async (centerId: string, templateId: string) => {
    const res = await apiClient.delete(`v1/centers/${centerId}/group-class-templates/${templateId}`);
    return { status: res.status, data: await safeJson(res) };
};

/* ═══════ 수업 생성 (단일+반복) — API_CONTRACT §1.1 ═══════ */

export const createGroupClass = async (centerId: string, body: Record<string, any>) => {
    const res = await apiClient.post(`v1/centers/${centerId}/group-classes`, { json: body });
    return { status: res.status, data: await safeJson(res) };
};

/* ═══════ 세션 ═══════ */

export const createSession = async (centerId: string, body: CreateSessionBody) => {
    const res = await apiClient.post(`v1/centers/${centerId}/group-sessions`, { json: body });
    return { status: res.status, data: await safeJson(res) as CreateSessionResponse | null };
};

export const getGroupSessions = async (centerId: string, params: Record<string, string>) => {
    const res = await apiClient.get(`v1/centers/${centerId}/group-sessions`, { searchParams: params });
    return { status: res.status, data: await safeJson(res) as { success: boolean; results: GroupSession[] } | null };
};

export const getGroupSessionDetail = async (centerId: string, sessionId: string) => {
    const res = await apiClient.get(`v1/centers/${centerId}/group-sessions/${sessionId}`);
    return { status: res.status, data: await safeJson(res) as GroupSessionDetailResponse | null };
};

export const updateGroupSession = async (centerId: string, sessionId: string, body: Record<string, any>) => {
    const res = await apiClient.put(`v1/centers/${centerId}/group-sessions/${sessionId}`, { json: body });
    return { status: res.status, data: await safeJson(res) };
};

export const completeGroupSession = async (centerId: string, sessionId: string, body: { attendances: Array<{ memberId: string; status: string }> }) => {
    const res = await apiClient.post(`v1/centers/${centerId}/group-sessions/${sessionId}/complete`, { json: body });
    return { status: res.status, data: await safeJson(res) };
};

export const deleteGroupSession = async (centerId: string, sessionId: string, scope: DeleteSessionScope = 'single') => {
    const res = await apiClient.delete(`v1/centers/${centerId}/group-sessions/${sessionId}`, { searchParams: { scope } });
    return { status: res.status, data: await safeJson(res) as DeleteGroupSessionResponse | null };
};
